import styled from 'styled-components';

/**
 * Below this the five cards stop fitting one row, so they become a slider
 * (the dashboard's Today cards switch around the same width).
 */
const SLIDER_BELOW = 1248;

/** Five in one row: they never wrap, the slider takes over first. */
export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: ${SLIDER_BELOW}px) {
    display: none;
  }
`;

export const SummarySlider = styled.div`
  display: none;

  @media (max-width: ${SLIDER_BELOW}px) {
    display: block;
  }
`;
